import React from 'react';
import Plot from 'react-plotly.js';

const ViolinPlot = ({data}) => {

  const plotData = [
    {
      y: data,
      type: 'violin',
      box: {
        visible: true,
      },
      meanline: {
        visible: true,
      },
    },
  ];

  const layout = {
    title: '<b>Violin Plot</b>',
    yaxis: {
      title: 'Values',
    },
    // autosize: true
  };

  return <Plot data={plotData} layout={layout}  style={{ width: "100%", height: "100%" }} />;
};

export default ViolinPlot;
